module.exports = __webpack_public_path__ + "static/assets/fbcd1e28b282ba1444efdb67b64d298f.png";